import { Reveal } from "./Reveal";

export default function KoerperGehirn() {
  return (
    <section data-testid="koerper-gehirn-section" className="bg-shell px-6 md:px-14 py-20 md:py-24">
      <div className="max-w-2xl mx-auto text-center">
        <Reveal>
          <h2 className="font-serif tracking-tight text-2xl md:text-3xl leading-tight text-espresso">
            Was passiert dabei in deinem Körper und Gehirn?
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mt-8 text-base md:text-lg font-light leading-relaxed text-taupe">
            Während dein Körper zur Ruhe kommt, können Atem und Muskulatur entspannen
            und deine Aufmerksamkeit richtet sich stärker nach innen.
          </p>
          <p className="mt-5 text-base md:text-lg font-light leading-relaxed text-taupe">
            Bei Entspannung, Meditation und hypnotischen Zuständen können sich auch
            Muster der Gehirnaktivität verändern. Unter anderem werden Alpha- und
            Theta-Aktivität mit entspannten und stärker nach innen gerichteten
            Zuständen in Verbindung gebracht.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mt-12">
            <span className="inline-block h-px w-16 bg-gold mb-8" aria-hidden="true" />
            <p className="font-serif italic text-xl md:text-2xl leading-relaxed text-espresso tracking-tight">
              Weniger Ablenkung.<br />Weniger Analysieren.<br />Mehr Aufmerksamkeit nach innen.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
